import { inject, Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ValidarTokenGuard implements CanActivate, CanLoad {
  private readonly authService = inject(AuthService);

  canActivate(): Observable<boolean> | boolean {
    return this.authService.validarToken();
  }

  canLoad(): Observable<boolean> | boolean {
    return this.authService.validarToken();
  }
}
